import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
  useIsMobile,
} from '@design-system';

import { SelfTestIntakeFormTab } from '@/features/invite-client';
import { useSelfTestIntakeFormDialogState } from '@/features/invite-client/hooks/use-self-test-intake-form-dialog';

const DESCRIPTION =
  'Use Waterlily to create a plan for your own long-term care needs. Your name is pre-filled from your account.';

export function SelfTestIntakeFormDialog() {
  const isMobile = useIsMobile();
  const { isAvailable, isOpen, clearInviteClientParams } = useSelfTestIntakeFormDialogState();

  const handleOpenChange = (open: boolean) => {
    if (!open) clearInviteClientParams();
  };

  if (!isAvailable) return null;

  if (isMobile) {
    return (
      <Drawer
        open={isOpen}
        onOpenChange={handleOpenChange}
      >
        <DrawerContent className="after:hidden! max-h-[90vh]! overflow-y-auto overflow-x-hidden px-4 pb-6">
          <DrawerHeader className="sr-only">
            <DrawerTitle>Plan for Yourself</DrawerTitle>
            <DrawerDescription>{DESCRIPTION}</DrawerDescription>
          </DrawerHeader>
          <SelfTestIntakeFormTab />
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <Dialog
      open={isOpen}
      onOpenChange={handleOpenChange}
    >
      <DialogContent className="max-h-[90vh] w-full overflow-y-auto overflow-x-hidden sm:max-w-xl">
        <DialogHeader className="sr-only">
          <DialogTitle>Plan for Yourself</DialogTitle>
          <DialogDescription>{DESCRIPTION}</DialogDescription>
        </DialogHeader>
        <SelfTestIntakeFormTab />
      </DialogContent>
    </Dialog>
  );
}
